import { useEffect, useState } from 'react';

interface UseDealDeltaToastOptions {
  delay?: number; // Delay in milliseconds, defaults to 3000ms
}

/**
 * Custom hook to handle delayed visibility of deal delta toast notifications
 * @param dealDeltaText - The deal delta text that triggers the toast visibility
 * @param options - Configuration options
 * @returns Object with showToast state and dismissToast function
 */
export const useDealDeltaToast = (
  dealDeltaText: string,
  options: UseDealDeltaToastOptions = {}
) => {
  const { delay = 3000 } = options;
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (dealDeltaText) {
      const timer = setTimeout(() => {
        setShowToast(true);
      }, delay);

      return () => clearTimeout(timer);
    } else {
      setShowToast(false);
    }
  }, [dealDeltaText, delay]);

  const dismissToast = () => {
    setShowToast(false);
  };

  return { showToast, dismissToast };
};
